import { ref } from "vue"
import api from "@/api/axios"
import Swal from "sweetalert2"

// Composable compartido por VueloManualModal.vue (cotizador automático) y
// CotizadorManual.vue (cotizador manual): pega una URL de Google Flights de
// un vuelo seleccionado y trae, ya resueltos, los tramos que traiga esa URL
// (ida, regreso y, si es multidestino, intermedio) y el precio total del
// itinerario — ver core/googleFlightsUrl.js y
// core/scrapearVueloGoogleFlights.js en el backend para el detalle de cómo
// se decodifica y se lee cada tramo.
export function useGoogleFlightsAutofill() {

  const loading = ref(false)

  async function parsearUrl(url) {
    loading.value = true

    try {
      const { data } = await api.post("/parsear-vuelo-google-flights", { url })

      if (!data.ok) throw new Error(data.error)

      const conError = data.tramos.filter(t => t.error)

      if (conError.length) {
        Swal.fire({
          icon: "warning",
          title: conError.length === data.tramos.length
            ? "No se pudo autocompletar"
            : "Algunos tramos no se autocompletaron",
          html: conError.map(t => `${t.origen} → ${t.destino}: ${t.error}`).join("<br>")
        })
      }

      return { tramos: data.tramos, precio: data.precio }

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "No se pudo leer la URL",
        text: err.response?.data?.error || err.message
      })
      return null

    } finally {
      loading.value = false
    }
  }

  // Convierte un tramo devuelto por el backend al shape que usa el
  // formulario (nuevoTramoVuelo en el frontend). Devuelve null si ese
  // tramo puntual no se pudo resolver.
  function tramoAFormulario(tramo) {
    if (!tramo || tramo.error) return null

    return {
      fecha: tramo.fecha,
      aerolinea: tramo.aerolinea,
      salida: tramo.salida,
      llegada: tramo.llegada,
      duracion: tramo.duracion,
      tipo: tramo.tipo,
      diasExtra: tramo.diasExtra,
      escalas: tramo.escalas
    }
  }

  return {
    loading,
    parsearUrl,
    tramoAFormulario
  }
}
